import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, ButtonGroup } from 'components/misc'

import styles from './filter-actions.styl'
import { FormattedMessage } from 'react-intl'

export default class FilterActions extends Component {
  static propTypes = {
    query: PropTypes.string,
    setFilter: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }

  handleSetFilter = e => {
    this.props.reset()
    this.props.setFilter()
    e.preventDefault()
  }

  render() {
    const { count, query } = this.props

    return (
      <ButtonGroup right paddedBottom={Boolean(count)}>
        {query && (
          <Button
            type="button"
            intlKey="button.clear"
            secondary
            onClick={this.handleSetFilter}
          >
            Clear
          </Button>
        )}
        <Button intlKey="button.filter">
          Filter
        </Button>
        {count && (
          <span className={styles.count}>
            <FormattedMessage
              id="label.number_of_records"
              defaultMessage="Number of records"
            />: {count}
          </span>
        )}
      </ButtonGroup>
    )
  }
}
